var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4FECC8BC-C15C-47B0-95EE-E729011F4642") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/question/inactive",
    fill: "#808080",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 C2.69154098,0 0,2.69154098 0,6 C0,9.30845902 2.69154098,12 6,12 C9.30845902,12 12,9.30845902 12,6 C12,2.69154098 9.30845902,0 6,0 Z M6.61704918,9.35147541 L5.2802623,9.35147541 L5.2802623,8.10386885 L6.61704918,8.10386885 L6.61704918,9.35147541 Z M7.48537705,5.9677377 C7.09088525,6.26137705 6.6692459,6.49993443 6.5867541,7.04065574 L6.5867541,7.3895082 L5.34885246,7.3895082 L5.34885246,6.97691803 C5.40367213,6.1787541 5.77967213,5.82137705 6.1464918,5.53704918 C6.50413115,5.25298361 6.81586885,5.04222951 6.81586885,4.5467541 C6.81586885,3.98727869 6.52262295,3.72144262 6.03672131,3.72144262 C5.37665574,3.72144262 5.1015082,4.26242623 5.09206557,4.91357377 L3.74413115,4.91357377 C3.77180328,3.60236066 4.63370492,2.64865574 5.97232787,2.64865574 C7.70544262,2.64865574 8.25586885,3.71239344 8.25586885,4.41809836 C8.25586885,5.30780328 7.87986885,5.66544262 7.48537705,5.9677377 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.736855ca1397d1447e73e4dc45011503.svg";
export { ForwardRef as ReactComponent };